export default __webpack_public_path__ + "static/media/petgramImg_1.52c4a722.webp";